import Modal from './Modal';
import { ModalFormFooter } from './ModalFormFooter';

/** Modal wrapper for an external `<form id={formId}>`.
 *
 * Extracted from the store-management CRUD pages
 * (MarketRegularizationReasonsPage / StoreCategoriesPage), where both inlined
 * the same `<Modal ... footer={<ModalFormFooter onCancel={...} .../>}>` wiring:
 * the modal's `onClose` and the footer's `onCancel` ran the identical
 * close-and-reset sequence. This wraps `<Modal>` and renders a
 * `<ModalFormFooter>` footer whose `onCancel` reuses the single `onClose`
 * handler, so the rendered DOM is byte-identical to the inlined markup. The
 * form body is passed as `children`. */
export default function FormModal({
  isOpen,
  onClose,
  title,
  size = 'md',
  formId,
  isSubmitting,
  submitLabel,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  formId: string;
  isSubmitting: boolean;
  submitLabel: string;
  children: React.ReactNode;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={(
        <ModalFormFooter
          onCancel={onClose}
          formId={formId}
          isSubmitting={isSubmitting}
          submitLabel={submitLabel}
        />
      )}
    >
      {children}
    </Modal>
  );
}
